import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { NavLink, Redirect } from 'react-router-dom';
import { BaseComponent, ChiamaAPI, BottoneAPI, Trad, Tipo, InputCalcolatore, Contesto, CampoNumero, CampoData } from '../components/';
import { FileDett, FileLista } from '../form/';

interface IDatiEconomiciState {
    Dato: Dati.CRisAPIDatoDatiEconomici;
}

export class DatiEconomici extends BaseComponent<Glob.IRouteGlobaleProps, IDatiEconomiciState> {

    private ID_DatoEconomico: number = 0;
    private BaseLink: string = "";

    constructor(props: any) {
        super(props);
        let Dato: Dati.CRisAPIDatoDatiEconomici;
        Dato = new Dati.CRisAPIDatoDatiEconomici();
        Dato.Dato.ID_Anag = (this.props.match.params as any).ID_Anag;
        this.state = { Dato };
        this.ID_DatoEconomico = (this.props.match.params as any).ID_DatoEconomico;
        this.OnRis = this.OnRis.bind(this);
        this.OnChange = this.OnChange.bind(this);
        this.OnClickSalva = this.OnClickSalva.bind(this);
        this.OnClickEstraiDati = this.OnClickEstraiDati.bind(this);

        this.BaseLink = "/anagrafica/" + (this.props.match.params as any).ID_Anag;
        if ((this.props.match.params as any).ID_FideAffidamento != undefined) {
            this.BaseLink += "/fideaffidamento/" + (this.props.match.params as any).ID_FideAffidamento;

            var M = Glob.GetMenu();
            M.Main = "Affidamento";
            M.ID_MenuMain = 24;
            M.VariabiliMenu = { ["{ID_FideAffidamento}"]: (this.props.match.params as any).ID_FideAffidamento.toString() };
            this.props.SetMenu(M);
        }
        this.BaseLink += "/DatiEconomici/";
    }

    protected OnChangeTag(e: React.FormEvent<any>): any {
        e.currentTarget.value = e.currentTarget.value.toUpperCase();
        this.OnChange(e);
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIDatoDatiEconomici, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            if (dati.Dato.ID_DatoEconomico > 0) {
                this.setState({ Dato: dati });

                let menu = 0;
                if (dati.Dato.ID_DatoEconomico > 0) {
                    menu = 24;
                }
                var M = Glob.GetMenu();
                M.Main = "Affidamento";
                M.ID_MenuMain = menu;
                this.props.SetMenu(M);
            }
            else {
                this.state.Dato.Dato.ID_Anag = (this.props.match.params as any).ID_Anag;
                this.setState({ Dato: this.state.Dato });
            }
        }
        return false;
    }

    private OnClickEstraiDati(sender: BottoneAPI, dati: Dati.CRisAPIDatoDatiEconomici) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            this.setState({ Dato: dati });
            this.ID_DatoEconomico = dati.ID_Chiave;
            this.props.history.replace(this.BaseLink + this.ID_DatoEconomico);
            Glob.InfoModaleSuccess(Trad.Trad("DATI ECONOMICI"), Trad.Trad("DatiEconomiciEstrattiCorrettamente"));
        }
    }

    private OnClickSalva(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            this.ID_DatoEconomico = dati.ID_Chiave;
            var tmp: Dati.CRisAPIDatoDatiEconomici = this.state.Dato;
            tmp.Dato.ID_DatoEconomico = this.ID_DatoEconomico;
            this.setState({ Dato: tmp });
            this.props.history.replace(this.BaseLink + this.ID_DatoEconomico);
            Glob.InfoModaleSuccess(Trad.Trad("DATI ECONOMICI"), Trad.TradParam("Dati economici salvati correttamente con ID: {1-S}", [this.ID_DatoEconomico]));
        }
    }

    private OnInvioSalva(sender: BottoneAPI): any {
        var Ingr = new Dati.CIngrAPI<Dati.CDatiEconomici>();
        Ingr.Dato = this.state.Dato.Dato;
        return Ingr;
    }

    private OnErroreBottoneAPI(sender: BottoneAPI, errore: Error) {
    }

    public render() {
        if (!this.ControlloAutorizzazione("DatiEconomiciController")) {
            this.props.history.push("/ErroreAccesso");
            return false;
        }

        var caricaDocumenti = <div></div>;
        if (this.ID_DatoEconomico > 0) {
            caricaDocumenti = <div className="kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push" aria-expanded="true">
                <a href={"/file/" + this.state.Dato.Dato.ID_DatoEconomico} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg black" title={Trad.Trad("Documenti")}>
                    <i className="fa fa-archive"></i></a>
            </div>;
        }
        let anagrafiche = <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="Dato.ID_Anag" ID_ChiaveString={this.state.Dato.Dato.ID_Anag.toString() || ""} OnAggiorna={this.OnChange} TradValori />;
        if ((this.props.match.params as any).ID_Anag != undefined && (this.props.match.params as any).ID_Anag != null && (this.props.match.params as any).ID_Anag != "" && (this.props.match.params as any).ID_Anag != 0) {
            anagrafiche = <Tipo URL="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca=" Campo="Dato.ID_Anag" ID_ChiaveString={this.state.Dato.Dato.ID_Anag.toString() || ""} OnAggiorna={this.OnChange} Disabilitato TradValori />;
        }
        let infoContesto: Dati.InfoContesto[] = [];
        infoContesto.push(new Dati.InfoContesto(Trad.Trad("Anagrafica"), "/api/anag/Contesto?ID_Anag=" + (this.props.match.params as any).ID_Anag, "/anagrafica/" + (this.props.match.params as any).ID_Anag));

        return <div>
            <Contesto Id="InfoContesto" Info={infoContesto} Name="Contesto" OnChange={this.OnChange} />
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon">
                                <i className="fa fa-money-bill"></i>
                            </span>
                            <h3 className="kt-portlet__head-label">{Trad.Trad("Dati economici")}</h3>
                        </div>
                    </div>
                    <div className="portlet__head-tools">
                        <ul className="kt-portlet__nav">
                            {caricaDocumenti}
                            <div className={"kt-portlet__nav-item kt-dropdown kt-dropdown--inline kt-dropdown--arrow kt-dropdown--align-right kt-dropdown--align-push " + this._VisibileScrittura} aria-expanded="true">
                                <NavLink to={this.BaseLink + "0"} className="kt-portlet__nav-link kt-portlet__nav-link--icon kt-portlet__nav-link--icon-lg" title={Trad.Trad("Nuovo")}>
                                    <i className="fa fa-plus"></i>
                                </NavLink>
                            </div>
                        </ul>
                    </div>
                </div>
                <form className="kt-form login-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-4">
                                <label>ID</label>
                                <input className="form-control kt-input" placeholder="ID" type="text" name="Dato.ID_DatoEconomico" value={this.state.Dato.Dato.ID_DatoEconomico || ""} readOnly />
                            </div>
                            <div className="col-lg-4">
                                <label className="">{Trad.Trad("Nominativo")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    {anagrafiche}
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">{Trad.Trad("Data")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <div className="form-control">
                                        <CampoData ValoreInArrivo={this.ID_DatoEconomico > 0}
                                            Name="Dato.Data"
                                            Id="Dato.Data"
                                            Valore={this.state.Dato.Dato.Data}
                                            OnChange={this.OnChange} />
                                    </div>
                                    <span className="kt-input-icon__icon kt-input-icon__icon--right">
                                        <span>
                                            <i className="la la-calendar"></i>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Anno Bilancio")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input className="form-control kt-input" placeholder={Trad.Trad("Anno Bilancio")} type="number" min="2000" max="2099" name="Dato.AnnoBilancio" value={this.state.Dato.Dato.AnnoBilancio || ""} onChange={this.OnChange} />
                                    <span className="kt-input-icon__icon kt-input-icon__icon--right">
                                        <span>
                                            <i className="la la-calendar"></i>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Fatturato")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero Id="Dato.Fatturato" Valore={this.state.Dato.Dato.Fatturato} OnChange={this.OnChange} Name="Dato.Fatturato" CSS="form-control kt-input" Icona="la la-money" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Patrimonio netto")}
                                </label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero Id="Dato.PatrimonioNetto" Valore={this.state.Dato.Dato.PatrimonioNetto} OnChange={this.OnChange} Name="Dato.PatrimonioNetto" CSS="form-control kt-input" Icona="la la-money" />
                                </div>
                            </div>
                        </div>

                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Margine Operativo Lordo")}
                                </label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero Id="Dato.MargineOperativoLordo" Valore={this.state.Dato.Dato.MargineOperativoLordo} OnChange={this.OnChange} Name="Dato.MargineOperativoLordo" CSS="form-control kt-input" Icona="la la-money" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Attivo circolante")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero Id="Dato.AttivoCircolante" Valore={this.state.Dato.Dato.AttivoCircolante} OnChange={this.OnChange} Name="Dato.AttivoCircolante" CSS="form-control kt-input" Icona="la la-money" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Debiti a breve")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero Id="Dato.DebitiBreve" Valore={this.state.Dato.Dato.DebitiBreve} OnChange={this.OnChange} Name="Dato.DebitiBreve" CSS="form-control kt-input" Icona="la la-money" />
                                </div>
                            </div>
                        </div>

                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Valore Produzione Ultimo Anno")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero Id="Dato.ValoreProduzioneUltimoAnno" Valore={this.state.Dato.Dato.ValoreProduzioneUltimoAnno} OnChange={this.OnChange} Name="Dato.ValoreProduzioneUltimoAnno" CSS="form-control kt-input" Icona="la la-money" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Valore produzione anno precedente")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero Id="Dato.ValoreProduzioneAnnoPrecedente" Valore={this.state.Dato.Dato.ValoreProduzioneAnnoPrecedente} OnChange={this.OnChange} Name="Dato.ValoreProduzioneAnnoPrecedente" CSS="form-control kt-input" Icona="la la-money" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Totale passivo")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero Id="Dato.TotalePassivo" Valore={this.state.Dato.Dato.TotalePassivo} OnChange={this.OnChange} Name="Dato.TotalePassivo" CSS="form-control kt-input" Icona="la la-money" />
                                </div>
                            </div>
                        </div>
                        <div className="form-group m-form__group row">
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("DebitiOltreBTVersoBanche")}</label>
                                <div className="m-input-icon m-input-icon--right">
                                    <CampoNumero Id="Dato.DebitiOltreBTVersoBanche" Valore={this.state.Dato.Dato.DebitiOltreBTVersoBanche} OnChange={this.OnChange} Name="Dato.DebitiOltreBTVersoBanche" CSS="form-control m-input" Icona="la la-money" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("DebitiCorrentiVersoBanche")}</label>
                                <div className="m-input-icon m-input-icon--right">
                                    <CampoNumero Id="Dato.DebitiCorrentiVersoBanche" Valore={this.state.Dato.Dato.DebitiCorrentiVersoBanche} OnChange={this.OnChange} Name="Dato.DebitiCorrentiVersoBanche" CSS="form-control m-input" Icona="la la-money" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("AttivitaFinanziarie")}</label>
                                <div className="m-input-icon m-input-icon--right">
                                    <CampoNumero Id="Dato.AttivitaFinanziarie" Valore={this.state.Dato.Dato.AttivitaFinanziarie} OnChange={this.OnChange} Name="Dato.AttivitaFinanziarie" CSS="form-control m-input" Icona="la la-money" />
                                </div>
                            </div>
                        </div>
                        <div className="form-group m-form__group row">
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Liquidita")}</label>
                                <div className="m-input-icon m-input-icon--right">
                                    <CampoNumero Id="Dato.Liquidita" Valore={this.state.Dato.Dato.Liquidita} OnChange={this.OnChange} Name="Dato.Liquidita" CSS="form-control m-input" Icona="la la-money" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("PassivoConsolidato")}</label>
                                <div className="m-input-icon m-input-icon--right">
                                    <CampoNumero Id="Dato.PassivoConsolidato" Valore={this.state.Dato.Dato.PassivoConsolidato} OnChange={this.OnChange} Name="Dato.PassivoConsolidato" CSS="form-control m-input" Icona="la la-money" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("PassivoCorrente")}</label>
                                <div className="m-input-icon m-input-icon--right">
                                    <CampoNumero Id="Dato.PassivoCorrente" Valore={this.state.Dato.Dato.PassivoCorrente} OnChange={this.OnChange} Name="Dato.PassivoCorrente" CSS="form-control m-input" Icona="la la-money" />
                                </div>
                            </div>
                        </div>
                        <div className="form-group m-form__group row">
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Classificazione")}
                                </label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input className="form-control kt-input" type="text" name="Dato.Classificazione" value={this.state.Dato.Dato.Classificazione || ""} onChange={this.OnChange} />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">{Trad.Trad("DataCostituzione")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <div className="form-control">
                                        <CampoData ValoreInArrivo={this.ID_DatoEconomico > 0}
                                            Name="Dato.DataCostituzione"
                                            Id="Dato.DataCostituzione"
                                            Valore={this.state.Dato.Dato.DataCostituzione}
                                            OnChange={this.OnChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("NumeroDipendenti")}
                                </label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero Id="Dato.NumeroDipendenti" Valore={this.state.Dato.Dato.NumeroDipendenti} OnChange={this.OnChange} Name="Dato.NumeroDipendenti" CSS="form-control kt-input" Icona="la la-smile-o" Precisione={0} />
                                </div>
                            </div>
                        </div>

                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Anno Unico")}
                                </label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input className="form-control kt-input" placeholder={Trad.Trad("Anno Unico")} type="number" min="2000" max="2099" name="Dato.AnnoUnico" value={this.state.Dato.Dato.AnnoUnico || ""} onChange={this.OnChange} />
                                    <span className="kt-input-icon__icon kt-input-icon__icon--right">
                                        <span>
                                            <i className="la la-calendar"></i>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Reddito Immobili")}
                                </label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero Id="Dato.RedditoImmobili" Valore={this.state.Dato.Dato.RedditoImmobili} OnChange={this.OnChange} Name="Dato.RedditoImmobili" CSS="form-control kt-input" Icona="la la-money" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <label className="">
                                    {Trad.Trad("Reddito complessivo")}
                                </label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <CampoNumero Id="Dato.RedditoComplessivo" Valore={this.state.Dato.Dato.RedditoComplessivo} OnChange={this.OnChange} Name="Dato.RedditoComplessivo" CSS="form-control kt-input" Icona="la la-money" />
                                </div>
                            </div>
                        </div>
                        <div className="form-group kt-form login-form__group row">
                            <div className="col-lg-12">
                                <label className="">
                                    {Trad.Trad("Commenti")}</label>
                                <div className="kt-input-icon kt-input-icon--right">
                                    <textarea className="form-control" id="kt_autosize_1" rows={3} name="Dato.Commenti" value={this.state.Dato.Dato.Commenti || ""} onChange={this.OnChange}></textarea>
                                </div>
                            </div>
                        </div>
                        {this.ID_DatoEconomico > 0 && this.state.Dato.Dato.NomeFileReport != undefined && this.state.Dato.Dato.NomeFileReport.length > 0 &&
                            <div className="form-group kt-form login-form__group row">
                                <div className="col-lg-12">
                                    <a href={"/api/DatiEconomici/Scarica?ID_DatoEconomico=" + this.ID_DatoEconomico + "&Sessione=" + Glob.GetSessione().Sessione}>{Trad.Trad("DownloadReport")}</a>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--right">
                            <div className="row">
                                <div className="col kt-form__actions kt-form__actions--right">
                                    <div className="divtabella">  <BottoneAPI Default Testo={Trad.Trad("Estrai dati")} URL="/api/DatiEconomici/EstraiDati" Metodo="POST" OnInvio={(s) => this.OnInvioSalva(s)} OnClick={(s, d) => this.OnClickEstraiDati(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Visibile={this._Scrittura} />
                                    </div>
                                    <div className="divtabella">
                                        <BottoneAPI Default={false} Testo={Trad.Trad("Salva")} URL="/api/DatiEconomici/" Metodo="POST" OnInvio={(s) => this.OnInvioSalva(s)} OnClick={(s, d) => this.OnClickSalva(s, d)} OnErrore={(s, e) => this.OnErroreBottoneAPI(s, e)} Visibile={this._Scrittura} />
                                    </div>
                                    <div className="divtabella">
                                        <ChiamaAPI Aggiornare={1} URL={"/api/DatiEconomici/seleziona?ID_DatoEconomico=" + this.ID_DatoEconomico} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErrore} />
                                        <button className={"btn btn-secondary " + this._VisibileScrittura} onClick={history.back} style={{ marginLeft: 5 }}>{Trad.Trad("Annulla")}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/form/DatiEconomici.tsx